var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
        persistent: "",
        "content-class": "service-dialog",
        "max-width": "600px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "SecondaryBtn",
                _vm._g({ attrs: { icon: "edit", small: "" } }, on),
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("Button.EditService")) + "\n    "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [_vm._v("Edit Service")]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.service.name) +
                            "\n          "
                        ),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c(
                  "v-card",
                  { attrs: { flat: "" } },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c("ServiceForm", {
                          ref: "serviceComponent",
                          attrs: { service: _vm.service },
                          on: {
                            validate: _vm.onValidate,
                            submit: _vm.onSubmit,
                            block: _vm.onBlock,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("ConfirmationDialog", {
                          attrs: {
                            disabled: _vm.isBlocked,
                            label: "Remove",
                            title: "Remove service",
                            text: "Are you sure you want to remove this service?",
                          },
                          on: { submit: _vm.remove },
                        }),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: !_vm.isValidated || _vm.isBlocked,
                              color: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submit()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("done"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("Button.Save")) + "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "secondary",
                              outline: "",
                              disabled: _vm.isBlocked,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }